import { render, staticRenderFns } from "./measurement.vue?vue&type=template&id=37c3527a&scoped=true&"
import script from "./measurement.vue?vue&type=script&lang=js&"
export * from "./measurement.vue?vue&type=script&lang=js&"
import style0 from "./measurement.vue?vue&type=style&index=0&id=37c3527a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c3527a",
  null
  
)

export default component.exports